import React, { Component } from 'react';
import config from 'react-global-configuration';

// Importação do Router
import { Link, Redirect} from 'react-router-dom';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import RequestApi from '../Miscelania/RequestApi';
import ExamOpenedAcoes from './Elements/ExamOpenedAcoes';
import ExamIndexStatusAcoes from './Elements/ExamIndexStatusAcoes';
import ExamAcoes from './Elements/ExamAcoes';

class ExamsIndex extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      dados: [],
      pending: [],
      current: '',
      next: '',
      previous: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.botaoEdicaoTurma = this.botaoEdicaoTurma.bind(this);
    this.botaoEdicaoMateria = this.botaoEdicaoMateria.bind(this);
    this.botaoEdicaoAluno = this.botaoEdicaoAluno.bind(this);
    this.botaoEdicao = this.botaoEdicao.bind(this);
    this.selectRow = this.selectRow.bind(this);
    this.refreshTable = this.refreshTable.bind(this);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }

  // Handlers de form
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }


  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      var now = new Date();
      var reference = now.getFullYear();
      this.setState({loaded: 2}, this.loadData(reference));
    }
  }
  next() {
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    this.loadData(this.state.next);
  }

  previous() {
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    this.loadData(this.state.previous);
  }
  loadData(reference) {
    console.log(reference);
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/provas/'  + reference;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({
            dados: responseJson.data.index_data,
            pending:responseJson.data.pending,
            current: responseJson.data.current,
            previous: responseJson.data.previous,
            next: responseJson.data.next
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      });
    });
  }

  selectRow (cell, row) {
    if (row.span === 'aberta') {
      var span = (
        <span>
          {cell}
        </span>
      );
    } else if (row.span === 'aprovada_c') {
      var cell = cell + "(C)";
      var className = "label label-success";
      var span = (
        <ExamIndexStatusAcoes handleAlert={this.handleAlert} dadosProva={row} refreshTable={this.refreshTable} cell={cell} className={className} />

      );

    } else if (row.span === 'reprovada_C') {
      var cell = cell + "(C)";
      var className = "label label-danger";
      var span = (
        <ExamIndexStatusAcoes handleAlert={this.handleAlert} dadosProva={row} refreshTable={this.refreshTable} cell={cell} className={className} />
      );

    } else if (row.span === 'aprovada') {
      var cell = cell;
      var className = "label label-success";
      var span = (
        <ExamIndexStatusAcoes handleAlert={this.handleAlert} dadosProva={row} refreshTable={this.refreshTable} cell={cell} className={className} />
      );

    } else if (row.span === 'reprovada') {
      var cell = cell;
      var className = "label label-danger";
      var span = (
        <ExamIndexStatusAcoes handleAlert={this.handleAlert} dadosProva={row} refreshTable={this.refreshTable} cell={cell} className={className} />
      );

    } else if (row.span === 'vencida') {
      var span = (
        <span className="label label-default">
          {cell}
        </span>
      );

    } else if (row.span === 'contestada') {
      var cell = 'Contestada';
      var className = "label label-warning";
      var span = (
        <ExamIndexStatusAcoes handleAlert={this.handleAlert} dadosProva={row} refreshTable={this.refreshTable} cell={cell} className={className} />
      );

    } else if (row.span === 'importada') {
      var span = (
        <span className="label label-default">
          Importada
        </span>
      );

    }

    return span;
  }
  refreshTable(event) {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/provas', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        self.setState({status_loading: 2});
        if (responseJson.status === 'success') {
          self.setState({dados: responseJson.data});
        }
        self.handleAlert(event.message, event.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  botaoEdicao (cell, row) {
    var botao = '';
    if (parseInt(row.imported, 10) > 0) {
      botao = <ExamAcoes handleAlert={this.handleAlert} dadosProva={row} refreshTable={this.refreshTable} onlyExport={true} />
    } else if (row.status == 'aberta' || row.status == 'confirmada') {
      botao = <ExamOpenedAcoes dadosProva={row} handleAlert={this.handleAlert} refreshTable={this.refreshTable} loadData={this.loadData} />

    } else if(row.status == 'reprovada' || row.status == 'aprovada') {
      botao = <ExamAcoes handleAlert={this.handleAlert} dadosProva={row} refreshTable={this.refreshTable} />
    }

    return botao;
  }

  botaoEdicaoTurma (cell, row) {
    var url = '/turma/editar/' + row.team_id;
    var botao = (
      <Link to={url}>
        {cell}
      </Link>
    );

    return botao;
  }
  botaoEdicaoMateria (cell, row) {
    var url = '/materia/editar/' + row.matter_id;
    var botao = (
      <Link to={url}>
        {cell}
      </Link>
    );

    return botao;
  }
  botaoEdicaoAluno (cell, row) {
    var url = '/aluno/editar/' + row.staff_id;
    var botao = (
      <Link to={url}>
        {cell}
      </Link>
    );

    return botao;
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-fluid">
    <div className="conteudo">
      <div className="row">
        <div className="col-md-4">
          <button className="btn btn-primary" onClick={this.previous}><i className="fa fa-fw fa-chevron-left"></i> {this.state.previous}</button>
        </div>
        <div className="col-md-4">
          <h3 className="page-title text-center">{this.state.current}</h3>
        </div>
        <div className="col-md-4 text-right">
          <button className="btn btn-primary" onClick={this.next}>{this.state.next} <i className="fa fa-fw fa-chevron-right"></i></button>
        </div>
      </div>
        {this.state.pending.length > 0 ?
        <div>
          <hr/>
          <h3 className="page-title pull-left">Lista de provas em andamento</h3>
          <div className="clearfix"></div>
            <BootstrapTable data={this.state.pending} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há provas cadastrados', defaultSortName: 'id',  defaultSortOrder: 'desc'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

              <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>ID</TableHeaderColumn>

              <TableHeaderColumn dataField="staff_name" dataAlign="center" dataFormat={this.botaoEdicaoAluno} dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='300'>Aluno</TableHeaderColumn>

              <TableHeaderColumn dataField="matter_name" dataAlign="center" dataFormat={this.botaoEdicaoMateria} dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Matéria</TableHeaderColumn>

              <TableHeaderColumn dataField="team_code" dataAlign="center" dataFormat={this.botaoEdicaoTurma} dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Turma</TableHeaderColumn>

              <TableHeaderColumn dataField="training_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='300'>Treinamento</TableHeaderColumn>

              <TableHeaderColumn dataField="setting_level_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Nivel</TableHeaderColumn>

              <TableHeaderColumn dataField="created_at_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Gerada em</TableHeaderColumn>

              <TableHeaderColumn dataField="started_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Início da Realização</TableHeaderColumn>

            </BootstrapTable>
          <div className="clearfix"></div>
        </div>
        :
          ''
        }
      <hr/>
      <h3 className="page-title pull-left">Lista de provas</h3>
      <Link to="/prova/cadastrar" className="btn btn-primary pull-right"><i className="fa fa-plus"></i> Adicionar prova</Link>
      <div className="clearfix"></div>
      <hr/>

      <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há provas cadastrados', defaultSortName: 'id',  defaultSortOrder: 'desc'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>ID</TableHeaderColumn>

        <TableHeaderColumn dataField="staff" dataAlign="center" dataFormat={this.botaoEdicaoAluno} dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='300'>Aluno</TableHeaderColumn>

        <TableHeaderColumn dataField="matter" dataAlign="center" dataFormat={this.botaoEdicaoMateria} dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Matéria</TableHeaderColumn>

        <TableHeaderColumn dataField="team_code" dataAlign="center" dataFormat={this.botaoEdicaoTurma} dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Turma</TableHeaderColumn>

        <TableHeaderColumn dataField="training" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='300'>Treinamento</TableHeaderColumn>

        <TableHeaderColumn dataField="dificuldade" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Nivel</TableHeaderColumn>

        <TableHeaderColumn dataField="created_at_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Gerada em</TableHeaderColumn>

        <TableHeaderColumn dataField="creator" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Gerada por</TableHeaderColumn>

        <TableHeaderColumn dataField="exam_applied_start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Início da Realização</TableHeaderColumn>

        <TableHeaderColumn dataField="duration" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Duração</TableHeaderColumn>

        <TableHeaderColumn dataField="result" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Nota</TableHeaderColumn>

        <TableHeaderColumn dataField="status_str" dataFormat={this.selectRow} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Status</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoEdicao} width='150'>Ações</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default ExamsIndex;



// WEBPACK FOOTER //
// ./src/Components/Exams/ExamsIndex.js